import { c as _c } from "react/compiler-runtime";
import { Dropdown, IconButton, Tooltip } from 'platform/components';
import { Spinner } from 'platform/foundation';
import { Icon } from 'platform/foundation-tw';
import { match } from 'ts-pattern';
import { useState } from 'react';
import { suffixTestId, TestIdProps } from 'shared/web';
import { Preset } from '../../../../types/Api';
import { PresetButtonActions } from '../../../../types/PresetButtonActions';
import { PresetApiStateEnum } from '../../constants/PresetApiStateEnum';
export type PresetButtonProps = TestIdProps & {
  preset: Preset;
  active: boolean;
  unsaved: boolean;
  state: PresetApiStateEnum;
  rowCount: number | undefined;
  actions?: PresetButtonActions;
  isDisabled?: boolean;
  onClick: () => void;
};
export function PresetButton(props) {
  const $ = _c(30);
  const [hover, setHover] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  let t0;
  if ($[0] !== props.state) {
    t0 = match(props.state).with(PresetApiStateEnum.loading, _temp).with(PresetApiStateEnum.success, _temp2).with(PresetApiStateEnum.error, _temp3).otherwise(_temp4);
    $[0] = props.state;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const stateIcon = t0;
  let t1;
  if ($[2] !== props.state) {
    t1 = match(props.state).with(PresetApiStateEnum.success, _temp5).with(PresetApiStateEnum.error, _temp6).otherwise(_temp7);
    $[2] = props.state;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const iconColorClass = t1;
  const wrapperBgClass = props.active ? "bg-blue-500" : "bg-gray-100";
  const wrapperHoverClass = !props.isDisabled && props.active ? "hover:bg-blue-600" : "hover:bg-gray-200";
  const wrapperTextClass = props.active ? "text-white" : "";
  const buttonDisabledClass = props.isDisabled ? "opacity-30 pointer-events-none" : "";
  const dropdownTranslateClass = (hover || dropdownOpen) && !props.isDisabled ? "translate-x-[-5px]" : "translate-x-[24px]";
  const t2 = `overflow-hidden relative inline-flex h-8 flex-shrink-0 rounded-full leading-8 cursor-pointer select-none max-w-[200px] px-2 ${wrapperBgClass} ${wrapperHoverClass} ${wrapperTextClass}`;
  const t3 = props["data-testid"];
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setHover(true);
    t5 = () => setHover(false);
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = `absolute left-0 top-1/2 w-4 h-4 pr-[6px] box-content transition-transform duration-200 cubic-bezier-[0.4,0.14,0.3,1] translate-x-[-24px] -translate-y-1/2 pl-0 ${iconColorClass}`;
  let t7;
  if ($[6] !== stateIcon) {
    t7 = <div className="flex">{stateIcon}</div>;
    $[6] = stateIcon;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = props.rowCount !== undefined ? `${props.preset.title} (${props.rowCount})` : props.preset.title;
  const t10 = `flex-1 text-sm h-full whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-[200px] ${buttonDisabledClass}`;
  const t11 = props.unsaved && "* ";
  const t12 = props.rowCount !== undefined ? ` (${props.rowCount})` : null;
  let t13;
  if ($[11] !== props.onClick || $[12] !== props.preset.title || $[13] !== t10 || $[14] !== t11 || $[15] !== t12) {
    t13 = <button type="button" onClick={props.onClick} className={t10}>{t11}{props.preset.title}{t12}</button>;
    $[11] = props.onClick;
    $[12] = props.preset.title;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== props.preset.description || $[18] !== t13 || $[19] !== t9) {
    t14 = <Tooltip placement="top" label={t9} description={props.preset.description}>{t13}</Tooltip>;
    $[17] = props.preset.description;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== dropdownTranslateClass || $[22] !== props) {
    t15 = props.actions && <div className={`absolute right-0 mt-1 w-6 min-w-[24px] p-0 h-6 bg-white cursor-pointer rounded-full overflow-hidden transition-transform duration-200 delay-100 ${dropdownTranslateClass}`}><Dropdown isLazy={true} strategy="fixed" data-testid={suffixTestId("preset-actions-dropdown", props)} dropdownControl={<IconButton size="small" icon="navigation/more_vert" data-testid={suffixTestId("actions", props)} />} onClose={() => setDropdownOpen(false)} onOpen={() => setDropdownOpen(true)}>{props.actions}</Dropdown></div>;
    $[21] = dropdownTranslateClass;
    $[22] = props;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15 || $[26] !== t2 || $[27] !== t3 || $[28] !== t8) {
    t16 = <div role="group" className={t2} data-testid={t3} onMouseEnter={t4} onMouseLeave={t5}>{t8}{t14}{t15}</div>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t2;
    $[27] = t3;
    $[28] = t8;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}
function _temp7() {
  return "";
}
function _temp6() {
  return "text-red-500";
}
function _temp5() {
  return "text-green-500";
}
function _temp4() {
  return null;
}
function _temp3() {
  return <Icon value="alert/error" />;
}
function _temp2() {
  return <Icon value="action/check_circle" />;
}
function _temp() {
  return <Spinner size="small" />;
}